import React, { useEffect, useCallback, useState} from 'react';
import PlayButton from 'components/user/PlayButton.js';
import FreezeName from './FreezeName.js';
import {
    setFreezeDragging,
    setFrozenTrackPlaying
} from 'actions/index.js';
import {setSelectedFreeze} from 'actions/index.js';
import {connect} from 'react-redux';

const FrozenSample = ({
    oldPlaying,
    sample,
    setSampleDragging,
    setFreezeDragging,
    isTrackFrozen,
    color,
    isSelected,
    track,
    isPlaying,
    setSelectedFreeze,
    currentGlobalStep,
    column,
    number}) => { 
        const play = useCallback(() => {
            if (!isTrackFrozen) {
                // then we must first freeze
                column.saveAndPlayFrozen(number);
                return;
            }
            if (isPlaying) {
                // need to clear the midi effects
                column.playing = undefined;
            } else {
                column.playing = number;
            }
        }, [isPlaying, isTrackFrozen, number]);
        
        let progress = '';
        if (isPlaying) {
            let step = currentGlobalStep % track.pattern.length();
            let percentage = step / track.pattern.length();
            let list = [];
            for (let i=0; i < 16; i++ ){
                if (percentage > i * 1 / 16.0) {
                    list.push(i);
                }
            }
            let style = {
                backgroundColor: color
            };
            progress = (
                <div className={"frozen-progress"}>
                  {list.map((l,i) => <div key={i} style={style} className="progress-part"></div>)}
                </div>
            );
        }
 
        let className = "frozen-container";
        if (isSelected) {
            className += " selected";
        }
        return (
            <div
              onClick={() => setSelectedFreeze(sample.ipfsHash)}
              style={{backgroundColor: color}}
              className={className}>
              <PlayButton
                play={(e) => play()}
                isPlaying={isPlaying}/>
              {progress}
              <FreezeName sample={sample}/>
            </div>
        );
}

const mapStateToProps = (state, props) => {
    let id = props.track.sequencerEngine.getSequenceId();
    let currentStep = state.sequencer.currentStep[id] || 0;
    let currentGlobalStep = state.sequencer.currentGlobalStep[id] || 0;
    let playing = state.tracks.frozenTracksPlaying[props.track.subSequence.id] || {};
    let isResampling = state.tracks.isResampling === props.track.trackNumber;
    let isPlaying = props.column.playing === props.number;
    let isPreparingToFreeze = state.tracks.trackToFreeze && state.tracks.trackToFreeze.trackNumber === props.track.trackNumber;
    let tracksFrozen = state.tracks.tracksFrozen[props.track.subSequence.id] || {};
    let isTrackFrozen = tracksFrozen[props.track.id];

    return {
        oldPlaying: playing[props.track.id],
        isSelected: state.freeze.selectedFreeze === props.sample.ipfsHash,
        isPlaying: isPlaying,
        currentGlobalStep: (isPlaying || isPreparingToFreeze || isResampling) && currentGlobalStep,
        isPreparingToFreeze, 
        isResampling,
        frozenPatternPlaying: props.column.playing,
        isTrackFrozen: isTrackFrozen,
    };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
      setSelectedFreeze: (x) => dispatch(setSelectedFreeze(x)),
      setFreezeDragging: (x) => dispatch(setFreezeDragging(x)),
      setPlaying: (playing) => dispatch(setFrozenTrackPlaying(props.track.subSequence.id, props.track.id, playing)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FrozenSample);
